import React, { useEffect, useState, useRef } from 'react';
import Sidebar from '../components/Sidebar';
import "./dashboard.css";
import { Link, useSearchParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { getMemberAll, uploadsbulk } from '../services/dbService';
import PaginatedTable from '../services/paginatedtable';
import Swal from "sweetalert2";
import Membersmodal from './membersmodal';
import { usStates } from '../services/states'; // Assuming usStates is imported from here
import * as XLSX from "xlsx";
import { mediaURL } from '../services/api';
import { ProgressBar } from "react-bootstrap";

function Membersall() {
  const [searchParams] = useSearchParams();
  const [id, setId] = useState(null); // Unused, consider removing if not needed
  const [total, setTotal] = useState(); // Unused, consider removing if not needed
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [selectedMember, setSelectedMember] = useState(null);
  const role = localStorage.getItem("role");
  const isAdmin = role === 'admin';

  const [isOpen, setIsOpen] = useState(true); // Unused, consider removing if not needed
  const fileInputRef = useRef(null);
  const [fileName, setFileName] = useState("");
  const [validRows, setValidRows] = useState([]);
  const [invalidRows, setInvalidRows] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [uploadResults, setUploadResults] = useState(null); // State for API response details (post-upload)
  const templateFile = "memberupdloadformat.xlsx";

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getMemberAll();
      setData(Array.isArray(response?.data) ? response.data : []);
    } catch (err) {
      Swal.fire('Error', 'Error getting data.', 'error');
      setError('Error getting data.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchWithErrorHandling = async () => {
      try {
        await fetchData();
      } catch (error) {
        console.error("Error fetching data:", error);
        // Optionally show user-facing error message
        // errorMessage("Failed to fetch data. Please try again later.");
      }
    };
  
    fetchWithErrorHandling();
  }, []);
  
const handleEdit = (item) => {
  try {
    setSelectedMember(item);
    setIsModalOpen(true);
  } catch (error) {
    console.error("Error while editing member:", error);
    // Optionally show a user-friendly message
    // errorMessage("Failed to open edit modal. Please try again.");
  }
};


  // --- REFINED VALIDATION FUNCTION ---
  const validateRow = (row, originalRowIndex) => {
    try {
      const errors = [];
  
      // Validate date format: DD-MM-YYYY
      const dateRegex = /^\d{2}-\d{2}-\d{4}$/;
      if (row.join_date && !dateRegex.test(row.join_date)) {
        errors.push("Invalid Join Date format. Expected DD-MM-YYYY");
      }
      if (row.validupto && !dateRegex.test(row.validupto)) {
        errors.push("Invalid Valid Upto Date format. Expected DD-MM-YYYY");
      }
  
      // Validate email
      if (row.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(row.email)) {
        errors.push("Invalid Email format (example: user@example.com)");
      }
  
      // Required name fields
      if (!row.firstname || row.firstname.trim() === "") {
        errors.push("First Name is required");
      }
  
      if (!row.lastname || row.lastname.trim() === "") {
        errors.push("Last Name is required");
      }
  
      // Validate US state abbreviation
      if (row.state) {
        if (!usStates.some(state => state.abbreviation === row.state)) {
          errors.push(`Invalid State abbreviation. Use one of: ${usStates.map(state => state.abbreviation).join(", ")}`);
        }
      }
  
      // Validate ZIP code
      if (row.zipcode && !/^\d{5}(?:[-\s]?\d{4})?$/.test(row.zipcode)) {
        errors.push("Invalid ZIP Code format. Expected 5 digits or ZIP+4 (e.g., 12345 or 12345-6789)");
      }
  
      return {
        ...row,
        __rowIndex: originalRowIndex + 2, // Excel-style row numbering
        __errors: errors,
      };
    } catch (error) {
      console.error(`Validation error at row ${originalRowIndex + 2}:`, error);
      return {
        ...row,
        __rowIndex: originalRowIndex + 2,
        __errors: ["Unexpected error during validation"],
      };
    }
  };
  

  const handleFileUpload = (event) => {
    try {
      const file = event.target.files[0];
      if (!file) return;
  
      const extension = file.name.split(".").pop().toLowerCase();
      if (!["xls", "xlsx"].includes(extension)) {
        Swal.fire("Invalid File", "Please upload an Excel (.xls or .xlsx) file", "warning");
        return;
      }
  
      setFileName(file.name);
      setUploadResults(null);
      setInvalidRows([]);
      setValidRows([]);
  
      const reader = new FileReader();
  
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const sheet = workbook.Sheets[workbook.SheetNames[0]];
          const jsonData = XLSX.utils.sheet_to_json(sheet);
  
          // const parseExcelDate = (excelDate) => {
          //   if (!excelDate) return "";
          //   if (typeof excelDate === "number") {
          //     const jsDate = new Date(Math.round((excelDate - 25569) * 86400 * 1000));
          //     const day = String(jsDate.getDate()).padStart(2, '0');
          //     const month = String(jsDate.getMonth() + 1).padStart(2, '0');
          //     const year = jsDate.getFullYear();
          //     return `${day}-${month}-${year}`;
          //   } else if (typeof excelDate === "string") {
          //     const parts = excelDate.split(/[-/.]/);
          //     if (parts.length === 3) {
          //       if (parts[0].length === 4) {
          //         const parsedDate = new Date(`${parts[0]}-${parts[1]}-${parts[2]}`);
          //         if (!isNaN(parsedDate)) {
          //           return `${String(parsedDate.getDate()).padStart(2, '0')}-${String(parsedDate.getMonth() + 1).padStart(2, '0')}-${parsedDate.getFullYear()}`;
          //         }
          //       }
          //       if (parts[2].length === 4) {
          //         const parsedDate = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
          //         if (!isNaN(parsedDate)) {
          //           return `${String(parsedDate.getDate()).padStart(2, '0')}-${String(parsedDate.getMonth() + 1).padStart(2, '0')}-${parsedDate.getFullYear()}`;
          //         }
          //       }
          //     }
          //     const parsed = new Date(excelDate);
          //     if (!isNaN(parsed)) {
          //       const day = String(parsed.getDate()).padStart(2, '0');
          //       const month = String(parsed.getMonth() + 1).padStart(2, '0');
          //       const year = parsed.getFullYear();
          //       return `${day}-${month}-${year}`;
          //     }
          //   }
          //   return "";
          // };
  
          const parseExcelDate = (excelDate) => {
            if (!excelDate) return "";
          
            if (typeof excelDate === "number") {
              const utcDays = excelDate - 25569;
              const utcValue = utcDays * 86400 * 1000;
              const jsDate = new Date(utcValue); // Still affected by local time zone
              const utcDate = new Date(jsDate.getUTCFullYear(), jsDate.getUTCMonth(), jsDate.getUTCDate());
          
              const day = String(utcDate.getUTCDate()).padStart(2, '0');
              const month = String(utcDate.getUTCMonth() + 1).padStart(2, '0');
              const year = utcDate.getUTCFullYear();
          
              return `${day}-${month}-${year}`;
            }
          
            if (typeof excelDate === "string") {
              const parts = excelDate.split(/[-/.]/);
              let parsedDate;
          
              if (parts.length === 3) {
                if (parts[0].length === 4) {
                  parsedDate = new Date(Date.UTC(parts[0], parts[1] - 1, parts[2]));
                } else if (parts[2].length === 4) {
                  parsedDate = new Date(Date.UTC(parts[2], parts[1] - 1, parts[0]));
                }
              }
          
              if (!parsedDate || isNaN(parsedDate)) {
                parsedDate = new Date(excelDate); // fallback
              }
          
              if (!isNaN(parsedDate)) {
                const day = String(parsedDate.getUTCDate()).padStart(2, '0');
                const month = String(parsedDate.getUTCMonth() + 1).padStart(2, '0');
                const year = parsedDate.getUTCFullYear();
                return `${day}-${month}-${year}`;
              }
            }
          
            return "";
          };
          
          const formattedData = jsonData.map((row) => ({
            join_date: parseExcelDate(row.Join_date) || "",
            firstname: row.Firstname || "",
            lastname: row.Lastname || "",
            email: row.Email || "",
            mobile: row.Mobile || "",
            address: row.Address || "",
            addressline1: row.Addressline1 || "",
            addressline2: row.Addressline2 || "",
            addressline3: row.Addressline3 || "",
            state: row.State || "",
            zipcode: row.Zipcode || "",
            validupto: parseExcelDate(row.Validupto) || "",
            status: 1
          }));
  
          const validated = formattedData.map((row, index) => validateRow(row, index));
          setValidRows(validated.filter((r) => r.__errors.length === 0));
          setInvalidRows(validated.filter((r) => r.__errors.length > 0));
        } catch (innerError) {
          console.error("Error while parsing Excel data:", innerError);
          Swal.fire("Parsing Error", "Failed to parse Excel file. Please check the format.", "error");
        }
      };
  
      reader.onerror = () => {
        Swal.fire("Read Error", "Failed to read file. Please try again.", "error");
      };
  
      reader.readAsArrayBuffer(file);
    } catch (error) {
      console.error("Unexpected error during file upload:", error);
      Swal.fire("Upload Error", "An unexpected error occurred while uploading the file.", "error");
    }
  };
  
  const handleUpload = async () => {
    // Before attempting upload, re-validate all invalid rows one last time
    // This ensures any last-minute user edits are validated
    const reValidatedInvalidRows = invalidRows.map((row) =>
      validateRow(row, row.__rowIndex - 2) // Pass original index to validateRow
    );

    const currentlyValidRows = [
      ...validRows,
      ...reValidatedInvalidRows.filter((r) => r.__errors.length === 0),
    ];

    const stillInvalidRows = reValidatedInvalidRows.filter((r) => r.__errors.length > 0);

    // Update state to reflect any rows that became valid or are still invalid after final check
    setValidRows(currentlyValidRows.filter(r => r.__errors.length === 0)); // Ensure no errors in validRows
    setInvalidRows(stillInvalidRows); // Keep only those that still have errors

    if (stillInvalidRows.length > 0) {
      Swal.fire("Validation Errors", "Please correct the highlighted errors before uploading.", "error");
      return; // Stop upload if there are uncorrected frontend errors
    }

    if (!currentlyValidRows.length) {
      Swal.fire("No valid data to upload", "Please ensure there are valid rows to upload.", "warning");
      return;
    }

    const dataToUpload = currentlyValidRows.map(({ __errors, __rowIndex, ...rest }) => rest);

    setUploading(true);
    setUploadResults(null); // Clear previous results before starting a new upload
    try {
      const response = await uploadsbulk(dataToUpload);

      // Your API returns status 500 but with a data payload for detailed results
      if (response.status === 200 || response.status === 500) {
        setUploadResults(response.data.details); // Store the detailed results

        if (response.data.message.includes("issues")) {
          Swal.fire("Upload Completed", response.data.message, "warning");
        } else {
          Swal.fire("Success", response.data.message, "success");
        }
        resetUpload(); // Clear file input and row states (but keep uploadResults)
        fetchData(); // Refresh main table data
      } else {
        Swal.fire("Error", response.data?.error || "Error uploading data. Please try again.", "error");
      }
    } catch (err) {
      console.error("Upload failed:", err);
      Swal.fire("Error", err.response?.data?.error || "Upload failed due to a network or server error.", "error");
    } finally {
      setUploading(false);
    }
  };

  const handleFieldChange = (index, field, value) => {
    try {
      const updatedInvalidRows = [...invalidRows];
      const originalRowIndex = updatedInvalidRows[index].__rowIndex - 2;
  
      // Update the value of the changed field
      updatedInvalidRows[index][field] = value;
  
      // Re-validate the updated row
      const reValidatedRow = validateRow(updatedInvalidRows[index], originalRowIndex);
      updatedInvalidRows[index] = reValidatedRow;
  
      // Separate rows that are now valid or still invalid
      const newlyValid = updatedInvalidRows.filter(row => row.__errors.length === 0);
      const stillInvalid = updatedInvalidRows.filter(row => row.__errors.length > 0);
  
      // Remove newly valid rows from invalidRows
      setInvalidRows(stillInvalid);
  
      // Add newly valid rows to validRows, avoiding duplicates by __rowIndex
      setValidRows(prevValidRows => {
        const existingIndices = new Set(prevValidRows.map(row => row.__rowIndex));
        const filteredNewlyValid = newlyValid
          .filter(row => !existingIndices.has(row.__rowIndex))
          .map(({ __errors, ...rest }) => rest);
  
        return [...prevValidRows, ...filteredNewlyValid];
      });
    } catch (error) {
      console.error("Error in handleFieldChange:", error);
      Swal.fire("Error", "An unexpected error occurred while updating the row.", "error");
    }
  };
  

  const resetUpload = () => {
    try {
      setFileName("");
      setValidRows([]);
      setInvalidRows([]);
      setUploadResults(null); // Clear upload results
      if (fileInputRef.current) {
        fileInputRef.current.value = ""; // Clear the file input
      }
    } catch (error) {
      console.error("Error resetting upload state:", error);
      Swal.fire("Error", "Failed to reset the upload. Please try again.", "error");
    }
  };
  

  return (
    <div>
      <Navbar />
      <Sidebar />
      {loading && (
        <div className="preloader">
          <div className="lds-ripple">
            <div className="lds-pos"></div>
            <div className="lds-pos"></div>
          </div>
        </div>
      )}

      <div id="main-wrapper">
        <div className="page-wrapper d-block">
          <div className="body-wrapper">
            <div className="container-fluid">
              <div className="folio-container"></div>
              <div className="row">
                <div className="col-lg-12 d-flex align-items-stretch">
                  <div className="card w-100">
                    <div className="card-header" style={{ background: "#f06969" }}>
                      <div className="d-sm-flex d-block align-items-center justify-content-between mb-4">
                        <h4 className="card-title fw-semibold">Members</h4>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="d-flex flex-wrap align-items-center gap-2 mb-4">
                        {isAdmin && (
                          <>
                            <button
                              className="btn btn-info btn-sm"
                              style={{ minWidth: 180 }}
                              onClick={() => window.open(`${mediaURL}/${templateFile}`, "_blank")}
                            >
                              Download Format
                            </button>

                            <div>
                              <input
                                type="file"
                                className="d-none"
                                accept=".xlsx, .xls"
                                onChange={handleFileUpload}
                                ref={fileInputRef}
                              />
                              <button
                                className="btn btn-success btn-sm"
                                style={{ minWidth: 180 }}
                                onClick={() => fileInputRef.current.click()}
                              >
                                Upload Data
                              </button>
                            </div>
                          </>
                        )}
                      </div>

                      <div className="col-lg-12">
                        {loading ? (
                          <p>Loading...</p>
                        ) : error ? (
                          <p className="text-danger">Error: {error}</p>
                        ) : data.length > 0 ? (
                          <div className="table-responsive">
                            <PaginatedTable
                              columns={[
                                "number",
                                "firstname",
                                "lastname",
                                "email",
                                "mobile",
                                "addressline1",
                                "addressline2",
                                "addressline3",
                                "state",
                                "zipcode",
                                "join_date",
                                "validupto_date",
                                "role",
                                "status",
                              ]}
                              data={data}
                              onEdit={handleEdit}
                              showpayments={true}
                            />
                          </div>
                        ) : (
                          <p>No data available</p>
                        )}
                      </div>

                      <div className="row mt-3">
                        <div className="col-lg-12">
                          {fileName && <p className="text-muted">Uploaded File: {fileName}</p>}
                          {uploading && <ProgressBar animated now={100} label="Uploading..." className="w-100 my-2" />}
                          {validRows.length > 0 && <p className="text-success">✅ {validRows.length} rows initially validated</p>}


                          {/* --- Display Frontend Validation Errors for Correction --- */}
                          {invalidRows.length > 0 && (
                            <div className="w-100 mt-3 border border-danger p-3 rounded">
                              <h5 className="text-danger">❌ {invalidRows.length} rows need correction:</h5>
                              <p className="text-muted small">Please correct the errors directly in the table below before uploading.</p>
                              <div className="table-responsive">
                                <table className="table table-bordered table-hover table-sm">
                                  <thead>
                                    <tr>
                                      <th>Row #</th>
                                      <th>First Name</th>
                                      <th>Last Name</th>
                                      <th>Email</th>
                                      <th>Mobile</th>
                                      <th>Joining Date</th>
                                      <th>Valid Upto</th>
                                      <th>State</th>
                                      <th>Zip Code</th>
                                      <th>Errors</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {invalidRows.map((row, i) => (
                                      <tr key={row.__rowIndex} className={row.__errors.length > 0 ? 'table-danger' : ''}>
                                        <td>{row.__rowIndex}</td> {/* Show original Excel row number */}
                                        <td>
                                          <input
                                            type="text"
                                            className={`form-control form-control-sm ${row.__errors.some(e => e.includes('First Name')) ? 'is-invalid' : ''}`}
                                            value={row.firstname}
                                            onChange={(e) => handleFieldChange(i, "firstname", e.target.value)}
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            className={`form-control form-control-sm ${row.__errors.some(e => e.includes('Last Name')) ? 'is-invalid' : ''}`}
                                            value={row.lastname}
                                            onChange={(e) => handleFieldChange(i, "lastname", e.target.value)}
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="email"
                                            className={`form-control form-control-sm ${row.__errors.some(e => e.includes('email format')) ? 'is-invalid' : ''}`}
                                            value={row.email}
                                            onChange={(e) => handleFieldChange(i, "email", e.target.value)}
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            className="form-control form-control-sm"
                                            value={row.mobile}
                                            onChange={(e) => handleFieldChange(i, "mobile", e.target.value)}
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            className={`form-control form-control-sm ${row.__errors.some(e => e.includes('Join Date')) ? 'is-invalid' : ''}`}
                                            value={row.join_date}
                                            placeholder="DD-MM-YYYY"
                                            onChange={(e) => handleFieldChange(i, "join_date", e.target.value)}
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            className={`form-control form-control-sm ${row.__errors.some(e => e.includes('Valid Upto')) ? 'is-invalid' : ''}`}
                                            value={row.validupto}
                                            placeholder="DD-MM-YYYY"
                                            onChange={(e) => handleFieldChange(i, "validupto", e.target.value)}
                                          />
                                        </td>
                                        <td>
                                          <select
                                            className={`form-select form-select-sm ${row.__errors.some(e => e.includes('State')) ? 'is-invalid' : ''}`}
                                            value={row.state}
                                            onChange={(e) => handleFieldChange(i, "state", e.target.value)}
                                          >
                                            <option value="">Select</option>
                                            {/* *** This is the key change *** */}
                                            {usStates.map((stateOption) => (
                                              <option key={stateOption.abbreviation} value={stateOption.abbreviation}>
                                                {stateOption.name}
                                              </option>
                                            ))}
                                          </select>
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            className={`form-control form-control-sm ${row.__errors.some(e => e.includes('Zip Code')) ? 'is-invalid' : ''}`}
                                            value={row.zipcode}
                                            onChange={(e) => handleFieldChange(i, "zipcode", e.target.value)}
                                          />
                                        </td>
                                        <td className="text-danger small">{row.__errors.join(", ")}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          )}
                          {/* --- End Frontend Validation Errors --- */}

                          {(validRows.length > 0 || (invalidRows.length > 0 && invalidRows.every(r => r.__errors.length === 0))) && (
                             <button
                                className="btn btn-primary btn-sm me-2"
                                style={{ marginTop: "20px" }}
                                onClick={handleUpload}
                                disabled={uploading || invalidRows.some(r => r.__errors.length > 0)} // Disable if any frontend errors
                             >
                               Final Upload
                             </button>
                          )}
                           {invalidRows.length > 0 && invalidRows.every(r => r.__errors.length === 0) && (
                            <p className="text-success mt-2">All errors corrected. Ready for upload!</p>
                           )}


                          {/* --- Section to display API Upload Results (Post-Upload) --- */}
                          {uploadResults && uploadResults.length > 0 && (
                            <div className="w-100 mt-4 border border-info p-3 rounded">
                              <h5>Upload Processing Summary:</h5>
                              <p className="text-muted small">Status of each row after attempting upload to server.</p>
                              <div className="table-responsive">
                                <table className="table table-bordered table-sm">
                                  <thead>
                                    <tr>
                                      <th>Row #</th>
                                      <th>Email</th>
                                      <th>Status</th>
                                      <th>Message</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {uploadResults.map((result, index) => (
                                      <tr key={index} className={result.status === 'Inserted' ? 'table-success' : 'table-warning'}>
                                        <td>{result.row_index}</td>
                                        <td>{result.email || 'N/A'}</td>
                                        <td>
                                          <span className={`badge bg-${result.status === 'Inserted' ? 'success' : 'warning'}`}>
                                            {result.status}
                                          </span>
                                        </td>
                                        <td>{result.message}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          )}
                          {/* --- End Upload Results Section --- */}

                        </div>
                      </div>
                    </div>
                  </div>
                  <Membersmodal
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                    reloadData={fetchData}
                    selectedMember={selectedMember}
                    edit={true}
                    type="primary"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Membersall;